// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthenticationModal_wrapper__O0DuI","modal":"AuthenticationModal_modal__q1Rk+","info":"AuthenticationModal_info__owfas"};